import { useRef } from 'react';
import Modal from '@sdk/components/ui/modal/Modal';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';
import ModalFooterActionButtons from '@sdk/components/ui/modal/ModalFooterActionButtons';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';

import BreakYellowSvg from '@web/assets/svg/Icons/32/break-yellow.svg';

type Props = {
  isVisible: boolean;
  accept: () => void;
  decline: () => void;
};

export const ConfirmExcessiveBreaksModal = ({ isVisible, accept, decline }: Props) => {
  const config = useRef({ noDismiss: true }).current;

  return (
    <Modal fixed config={config} isVisible={isVisible}>
      <ModalBodyWithHeader
        width={620}
        titleThemeColor={ThemeColorType.warning}
        titleText={gettext('Add break')}
        titleIcon={<BreakYellowSvg />}
        hideClose>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext(
            'Psst! New break will be added as excessive break, as attestation cannot be overwritten.'
          )}
        </Text14>
        <ModalFooterActionButtons
          mTop={20}
          cancel={decline}
          submit={accept}
          isSubmitAsync={false}
          cancelText={gettext('Back')}
          submitText={gettext('Add break')}
        />
      </ModalBodyWithHeader>
    </Modal>
  );
};
